import React from 'react';
import './FuelSensor.css';
import FMSimage from '../Assets/sensor.jpeg'; // First image (full size)
import FMSimage2 from '../Assets/sensor1.jpg'; // Image for Key Features & Benefits
import FMSimage3 from '../Assets/fuelsensor2.jpg'; // Image for How it Works section
import FMSimage4 from '../Assets/fuelsensor3.jpg'; // Image for Why Choose section
import FMSimage5 from '../Assets/fuelsensor4.jpg'; // Image for Industries section

const FMS = () => {
    return (
        <div className="FMS-container">
            {/* First Section: Layout for Text and Image */}
            <div className="FMS-content-container">
                {/* Left side: Text Content */}
                <div className="FMS-text">
                    <h1 className="FMS-heading">FUEL SENSOR SYSTEM</h1>
                    <p className="FMS-description">
                        The Fuel Sensor System from Vajra IoT is engineered to monitor and manage fuel levels with precision across various applications. It provides real-time fuel level tracking, theft detection, and usage analytics, making it ideal for industries such as transportation, logistics, and energy management. The system ensures accurate data collection, secure cloud integration, and remote monitoring, enabling efficient fuel management and cost optimization.
                    </p>
                </div>

                {/* Right side: Image */}
                <div className="FMS-image-container">
                    <img src={FMSimage} alt="Fuel Sensor System" className="FMS-image full-size" />
                </div>
            </div>

            {/* Centered Heading Between Images */}
            <div className="FMS-bottom-heading">
                <h2 className="FMS-bottom-text">Key Features & Benefits</h2>
            </div>

            {/* Second Section: New Layout for Text and Image */}
            <div className="FMS-content-container">
                {/* Left side: Text Content */}
                <div className="FMS-text">
                    <p className="FMS-description">
                        <ul>
                            <li><strong>Accurate Fuel Monitoring:</strong> Provides precise real-time fuel level measurements for tanks and vehicles.</li>
                            <li><strong>Cloud Integration:</strong> Seamlessly connects to cloud platforms for centralized data storage and advanced analytics.</li>
                            <li><strong>Theft Detection:</strong> Detects unauthorized fuel usage or theft with instant alerts for enhanced security.</li>
                            <li><strong>Scalable Design:</strong> Adapts to various tank sizes and fleet requirements, supporting diverse applications.</li>
                            <li><strong>Data Security:</strong> Ensures encrypted data transmission to protect sensitive fuel usage information.</li>
                        </ul>
                    </p>
                </div>

                {/* Right side: New Image for Key Features */}
                <div className="FMS-image-container">
                    <img src={FMSimage2} alt="Key Features" className="FMS-image smaller-size" />
                </div>
            </div>

            {/* Centered Heading for How it Works */}
            <div className="FMS-bottom-heading">
                <h2 className="FMS-bottom-text">How it Works</h2>
            </div>

            {/* Third Section: Layout for How it Works */}
            <div className="FMS-content-container">
                {/* Left side: Image */}
                <div className="FMS-image-container">
                    <img src={FMSimage3} alt="How It Works" className="FMS-image smaller-size" />
                </div>

                {/* Right side: Text Content */}
                <div className="FMS-text">
                    <p className="FMS-description">
                        <ul>
                            <li><strong>Real-Time Fuel Tracking:</strong> Sensors continuously monitor fuel levels, providing accurate and up-to-date data.</li>
                            <li><strong>Data Processing:</strong> Fuel data is processed locally or transmitted to a central server for detailed analysis.</li>
                            <li><strong>Seamless Connectivity:</strong> Supports multiple communication protocols for integration with existing fleet or facility systems.</li>
                            <li><strong>Alerting and Notifications:</strong> Sends instant alerts for low fuel levels, sudden drops, or potential theft incidents.</li>
                            <li><strong>Remote Monitoring:</strong> Enables remote access to fuel data via a cloud platform, facilitating efficient management.</li>
                        </ul>
                    </p>
                </div>
            </div>

            {/* New Section: Why Choose Us */}
            <div className="FMS-bottom-heading">
                <h2 className="FMS-bottom-text">Why Choose Our Fuel Sensor System</h2>
            </div>

            <div className="FMS-content-container">
                {/* Left side: Text Content */}
                <div className="FMS-text">
                    <p className="FMS-description">
                        <ul>
                            <li><strong>Optimized Fuel Management:</strong> Enhances fuel efficiency by providing precise usage data and reducing waste.</li>
                            <li><strong>Actionable Insights:</strong> Delivers detailed analytics for better decision-making in fuel consumption and logistics.</li>
                            <li><strong>Cost Savings:</strong> Minimizes losses from theft and overuse, lowering operational costs.</li>
                            <li><strong>Robust Performance:</strong> Designed for durability in harsh environments, ensuring reliable long-term operation.</li>
                        </ul>
                    </p>
                </div>

                {/* Right side: Image */}
                <div className="FMS-image-container">
                    <img src={FMSimage4} alt="Why Choose Us" className="FMS-image smaller-size" />
                </div>
            </div>

            {/* New Section: Industries Using Our Fuel Sensor System */}
            <div className="FMS-bottom-heading">
                <h2 className="FMS-bottom-text">Industries Using Our System</h2>
            </div>

            <div className="FMS-content-container reverse-order-last">
                {/* Left side: Image for Industries */}
                <div className="FMS-image-container">
                    <img src={FMSimage5} alt="Industries Using Fuel Sensor System" className="FMS-image smaller-size" />
                </div>

                {/* Right side: Text Content */}
                <div className="FMS-text">
                    <p className="FMS-description">
                        Our Fuel Sensor System is trusted across multiple sectors for its accuracy and reliability in fuel management:
                        <ul>
                            <li>Transportation & Logistics</li>
                            <li>Construction</li>
                            <li>Oil & Gas</li>
                            <li>Agriculture</li>
                            <li>Mining</li>
                        </ul>
                    </p>
                </div>
            </div>

        </div>
    );
};

export default FMS;